const formTypes = [
  { description: 'W-8BEN', family: 'W8BEN', value: 'W8BEN' },
  { description: 'W-8BEN-E', family: 'W8BENE', value: 'W8BENE' },
  { description: 'W-8ECI', family: 'W8ECI', value: 'W8ECI' },
  { description: 'W-8EXP', family: 'W8EXP', value: 'W8EXP' },
  { description: 'W-8IMY', family: 'W8IMY', value: 'W8IMY' },
  { description: 'W-9', family: 'W9', value: 'W9' },
  { description: 'CRSE', family: 'CRSE', value: 'CRSE' },
  { description: 'CRSCP', family: 'CRSCP', value: 'CRSCP' },
  { description: 'CRSI', family: 'CRSI', value: 'CRSI' },
  { description: 'FATCA/CRS-I', family: 'FATCACRSI', value: 'FATCACRSI' },
  { description: 'FATCA/CRS-E', family: 'FATCACRSE', value: 'FATCACRSE' }
];

export default formTypes;
